import React from 'react'

export default function Empty({ className }) {
    return (
        // <svg 
        //     className={`w-8 h-6 ${className}`}
        //     aria-hidden="true"
        //     fill="#23428b" 
        //     viewBox="0 0 32 32" 
        //     xmlns="http://www.w3.org/2000/svg" 
        //     version="1.1" 
        //     id="door" 
        //     enableBackground="new 0 0 32 32" 
        //     stroke="#23428b">
        //         <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        //         <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        //         <g id="SVGRepo_iconCarrier"> 
        //             <rect x="21" y="15" width="2" height="2"></rect> 
        //             <path d="M27 29V1H5v28H3v2h26v-2H27zM7 29V3h18v26H7z"></path>
        //         </g>
        // </svg>
        <svg 
            className={`w-8 h-6 ${className}`}
            viewBox="0 0 1024 1024" 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="#000000">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <path d="M151.963012 337.651783v30.025437h22.107732l7.917705 60.050874c0 11.025197 3.281552 21.170877 8.473675 30.025438h673.634633c5.191099-8.85456 8.475723-19.00024 8.475723-30.025438l7.975043-60.050874h22.050394v-30.025437H151.963012zM269.365799 790.671893c5.512599 31.433279 25.626826 57.294575 57.294575 57.294575h401.238133c31.667749 0 50.845121-25.392356 57.354985-57.294575l51.869006-302.892924h-619.686115l51.929416 302.892924z m146.373622-228.414482l21.231286-21.231286 90.310781 90.253444 90.310782-90.253444 21.228214 21.231286-90.310781 90.250372 90.604636 90.604636-21.231286 21.228215-90.601565-90.604636-90.604636 90.604636-21.228214-21.228215 90.602588-90.604636-90.311805-90.250372z" fill="#0b07ca"></path>
                    <path d="M121.937575 307.626346v30.025437h22.107732l7.917705 60.050874c0 11.025197 3.281552 21.170877 8.473675 30.025437h673.634633c5.191099-8.85456 8.475723-19.00024 8.475723-30.025437l7.975043-60.050874h22.050394v-30.025437H121.937575zM239.340362 760.646456c5.512599 31.433279 25.626826 57.294575 57.294575 57.294575H697.87307c31.667749 0 50.845121-25.392356 57.354984-57.294575l51.869007-302.892924h-619.686115l51.929416 302.892924z m146.373622-228.414482l21.231286-21.231286 90.310781 90.253444 90.310782-90.253444 21.228214 21.231286-90.310781 90.250372 90.604636 90.604636-21.231286 21.228215-90.601565-90.604637-90.604636 90.604637-21.228214-21.228215 90.602588-90.604636-90.311805-90.250372z" fill="#515361"></path>
                    <path d="M306.141858 413.762503a27.013167 57.402083 55.515 1 0 94.63014-65.001024 27.013167 57.402083 55.515 1 0-94.63014 65.001024Z" fill="#FEFEFE"></path><path d="M248.134573 508.228533a18.008095 31.51519 55.515 1 0 51.954332-35.687201 18.008095 31.51519 55.515 1 0-51.954332 35.687201Z" fill="#FEFEFE"></path>
                </g>
        </svg>

    )
}
{/* <svg 
   fill="#23428b" 
   viewBox="0 0 32 32" 
   xmlns="http://www.w3.org/2000/svg" 
   xmlns:xlink="http://www.w3.org/1999/xlink" 
   version="1.1" 
   id="door" 
   enableBackground="new 0 0 32 32" 
   xml:space="preserve" 
   stroke="#23428b">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier"> 
        <rect x="21" y="15" width="2" height="2"></rect> 
        <path d="M27 29V1H5v28H3v2h26v-2H27zM7 29V3h18v26H7z"></path>
    </g>
</svg> */}